import { TNavigation } from "../types/routes";

export enum Paths {
  HOME = '/',
  REPORT = 'report',
}